import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Input } from '../input';
import * as styles from './textarea.styles';

/** @type {import(".").TextareaType} */
const Textarea = forwardRef(({ className, ...props }, ref) => {
  return <Input ref={ref} as="textarea" className={clsx(styles.textarea, className)} {...props} />;
});

if (process.env.NODE_ENV !== 'production') {
  Textarea.displayName = 'Textarea';
}

export default Textarea;
